import React, { useEffect } from "react";
import { Route, Switch, Redirect, Link } from "react-router-dom";
import { BreadcrumbItem } from "reactstrap";
import { Navbar, NavbarProvider } from "@repoflow/components/navbar";
import {
  Sidebar,
  SidebarProvider
} from "@repoflow/components/sidebar-menu";
import { useAccount } from "@repoflow/components/account";
import { basename } from "env";
import * as AuthRoute from "./auth";
import * as DashboardRoute from "./dashboard";
import * as DayRoute from "./day";
import * as EntryRoute from "./entry";
import * as KeysRoute from "./keys";
import * as AccountRoute from "./account";

// The food log is what this service exists for, so the root lands on today
// rather than on the summary — the same call pagews makes for its sites. The
// sign-in flow points at the dashboard and keeps doing so; this is only where
// `/` goes.
const RootRoute = () => <Redirect to={`/day`} />;

function Routes() {
  const account = useAccount();

  useEffect(() => {
    if (!account && !window.location.pathname.startsWith(`${basename}/auth`)) {
      window.location.href = `${basename}/auth/home`;
    }
  }, [account]);

  return (
    <Switch>
      <Route path={`/auth`} component={AuthRoute.Content} />
      {/* No `component` prop here: in react-router v5 children take
          precedence over it, so one was always dead code. */}
      <Route path={`/`}>
        <NavbarProvider>
          <SidebarProvider>
            <Navbar title={"NoshChat"} menu={[]} />

            <Sidebar
              menu={[
                {
                  icon: "cutlery",
                  label: "Food log",
                  to: `/day`,
                },
                {
                  icon: "tachometer",
                  label: "Dashboard",
                  to: `/dashboard`,
                },
                {
                  icon: "key",
                  label: "API Keys",
                  to: `/key`,
                },
              ]}
            >
              <ol className="breadcrumb m-0 small">
                <BreadcrumbItem>
                  <Link to={`/`}>
                    <i className="fa fa-home"></i>
                  </Link>
                </BreadcrumbItem>
                <Switch>
                  <Route path={`/account`} component={AccountRoute.Indice} />
                  <Route path={`/dashboard`} component={DashboardRoute.Indice} />
                  <Route path={`/day`} component={DayRoute.Indice} />
                  <Route path={`/entry/:entryId`} component={EntryRoute.Indice} />
                  <Route path={`/key`} component={KeysRoute.Indice} />
                </Switch>
              </ol>

              <Switch>
                <Route path={`/account`} component={AccountRoute.Content} />
                <Route path={`/dashboard`} component={DashboardRoute.Content} />
                <Route path={`/day`} component={DayRoute.Content} />
                <Route path={`/entry/:entryId`} component={EntryRoute.Content} />
                <Route path={`/key`} component={KeysRoute.Content} />
                <Route path={`/`} component={RootRoute} />
              </Switch>
            </Sidebar>
          </SidebarProvider>
        </NavbarProvider>
      </Route>
    </Switch>
  );
}

export default Routes;
